import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";
import {
  ApiEnvelope,
  EncounterCodesForSuperBill,
} from "@/pages/app/provider/billings/billing-types";
import { EncounterSummaryControllerApi } from "../../services";
import { getConfigObject } from "../../utils/utils";

/**
 *
 * @author Atish Bagate
 */
interface GetuseGetCodesForSuperBills {
  appointmentUuid: string;
  cptBilled?: boolean;
  xTENANTID?: string;
}

export function useGetCodesForSuperBills({
  appointmentUuid,
  cptBilled,
  xTENANTID,
}: GetuseGetCodesForSuperBills): UseQueryResult<
  ApiEnvelope<EncounterCodesForSuperBill> | undefined,
  AxiosError
> {
  return useQuery({
    queryKey: [
      "Get-Code-For-Super-Bill",
      appointmentUuid,
      cptBilled,
      xTENANTID,
    ],
    enabled: !!appointmentUuid,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      new EncounterSummaryControllerApi(getConfigObject())
        .getCodesForSuperBills(appointmentUuid, cptBilled, xTENANTID)
        .then((it) => it?.data as ApiEnvelope<EncounterCodesForSuperBill>),
  });
}
